<template>
  <geneltanitim :tanitimTip="tanitimTip"></geneltanitim>
</template>

<script>
import geneltanitim from "@/components/app/customcomp/geneltanitim"

export default {
    name:'tevkifatkodu',
    data(){
        return{
            tanitimTip:302,
        }
    },
    components:{
        geneltanitim
    }

}
</script>

<style>

</style>